import { Storage } from '@iheartjane/utils';

export const resetSignInPrompt = () => Storage.remove('kioskSignInPrompt');
